var _effectorFileName = "/src/page-content/for-companies/model.ts";
import { pagesPath } from '@/shared/config/$path';
import { declarePage } from '@/shared/lib/effector/page';
export const forCompaniesPage = declarePage({
  pageType: pagesPath.$url().pathname
});